<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>编辑客户</h4>
        </div>
        <div class="main-bd mg20">
            <el-row>
            <el-col :span="12">
                <sub-form v-if="customer.id > 0" :model="customer" :scenario="'update'" @submit="submitForm"></sub-form>
            </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import CustomerService from "~/services/customer";
import subForm from "~/views/customer/form.vue";

export default {
    components: {
        subForm
    },

    data() {
        return {
            customer: null
        };
    },

    created() {
        if (this.customer == null) {
            this.customer = CustomerService.getModel();
        }
        this.getCustomerInfo(this.$route.query["id"]);
    },

    methods: {
        getCustomerInfo(customerId) {
            if (parseInt(customerId < 1)) {
                return false;
            }
            CustomerService.getInfo(customerId).then(res => {
                if (res.code != 0) return;
                    /**
                     * 此处不可这样写this.customer = res.data，如果这样写this.customer.stages对象就不
                     * 是一个vue.js 对象数组 “[__ob__: Observer]” 如果不是这种对象，elementui 中的
                     * el-checkbox-group 组件，就无法进行点击和选中，或可默认选中但无法进行取消勾选
                     * 所以就出现了如下写法，对this.custome中对对象一一赋值。
                     * author: zongqi
                     * date:2018-3-11
                     * this.customer = Object.assign(this.customer, res.data),就可以解决，[__ob__: Observer]是这样的一个对象。
                     * date:2018-7-19
                     **/

                    // this.customer = Object.assign(this.customer, res.data)
                    
        
                    // _.extend(this.customer, _.pick(res.data, [
                    //     'id', 'name', 'type', 'province_id', 'city_id', 'district_id'
                    // ]))                  

                    //此处为了兼容el-checkbox-group控件默认选中
                    let item = res.data;
                    this.customer.stages = [];
                    if (item.is_grade_school == '1') {
                        this.customer.stages.push('1');
                    }

                    if (item.is_middle_school == '1') {
                        this.customer.stages.push('2');
                    }

                    if (item.is_high_school == '1') {
                        this.customer.stages.push('3');
                    }
                    if (item.is_vsh_school == '1') {
                        this.customer.stages.push('4');
                    }

                    this.customer = Object.assign({}, this.customer, item)
            })
        },

        submitForm(customer,reset_form_callback) {

            customer.province_id = customer.province_id > 0 ? customer.province_id : '';
            customer.city_id = customer.city_id > 0 ? customer.city_id : '';
            customer.district_id = customer.district_id > 0 ? customer.district_id : '';

	        if (this.Acs('/customers/update') == true) {
		        CustomerService.update(customer).then(res => {
			        if (res.code == 0) {
				        this.$message({
					        message:'修改成功',
					        type:'success'
				        });
				        if (typeof reset_form_callback === 'function') reset_form_callback();
			        }
		        })
	        } else {
                CustomerService.updateMy(customer).then(res => {
                    if (res.code == 0) {
                        this.$message({
                            message:'修改成功',
                            type:'success'
                        });
                        if (typeof reset_form_callback === 'function') reset_form_callback();
                    }
                })
	        }
        }
    }

};
</script>


// WEBPACK FOOTER //
// src/views/customer/update.vue